// extracted by mini-css-extract-plugin
export default {"PromotedCategoriesContainer":"PromotedCategories_PromotedCategoriesContainer__TtIdv"};